import { Module } from "wrapper6";

export default class ContactTracking extends Module {
    ready() {
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            if(event.detail.contactFormId == 43){
                ga( 'send', 'event', 'Nyhedsbrev', 'submit', 'Nyhedsbrev' );
                dataLayer.push({'event': 'Nyhedsbrev', 'formName': 'Nyhedsbrev'});
            }else if(event.detail.contactFormId == 15944){
                ga( 'send', 'event', 'Kontaktformular', 'submit', 'Kontaktformular' );
                dataLayer.push({'event': 'Kontaktformular', 'formName': 'Kontaktformular'});
            }
        }, false );
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_contact-tracking.js